import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Select } from 'antd';
import _ from 'lodash';

const { Option } = Select;

const SIZES_RANGE = {
  '0 - 200': {
    gte: 0,
    lte: 200
  },
  '200 - 300': {
    gte: 200,
    lte: 300
  },
  '300 - 400': {
    gte: 300,
    lte: 400
  },
  '400 - 500': {
    gte: 400,
    lte: 500
  },
  '500 - 600': {
    gte: 500,
    lte: 600
  },
  '600 - 700': {
    gte: 600,
    lte: 700
  },
  '700 - 800': {
    gte: 700,
    lte: 800
  },
  '800 - 900': {
    gte: 800,
    lte: 900
  },
  '900 - 1000': {
    gte: 900,
    lte: 1000
  },
  '1000 - 1100': {
    gte: 1000,
    lte: 1100
  },
  '1100 - 1200': {
    gte: 1100,
    lte: 1200
  },
  '1200+': {
    gte: 1200
  }
};

const Filters = props => {
  const { filters, setFilters, setUnlocked = null, unlocked = true } = props;

  const handleChange = (value, field) => {
    if (setUnlocked) setUnlocked(false);
    if (!unlocked) return;
    if (typeof value === 'object') {
      if (!filters[field]) filters[field] = {};
      setFilters({ ...filters, [field]: { ...filters[field], ...value } });
      return;
    }
    setFilters({ ...filters, [field]: value });
  };

  useEffect(() => {
    setFilters({ ...filters, contractorId: '' });
  }, []);

  const getValueArea = () => {
    if (!filters.meta || !filters.meta.outerArea) return null;
    const key = `${filters.meta.outerArea.gte}${
      filters.meta.outerArea.lte ? ' - ' + filters.meta.outerArea.lte : '+'
    }`;

    return key;
  };

  return (
    <div style={{ display: 'block', marginTop: '10px' }}>
      <Row gutter={[8, 8]}>
        <Col span={8} lg={8}>
          <Select
            placeholder="Sq Ft"
            value={getValueArea()}
            style={{ width: '100%' }}
            onChange={value => handleChange({ outerArea: SIZES_RANGE[value] }, 'meta')}
          >
            <Option key="all" value="">
              Any
            </Option>
            {_.map(SIZES_RANGE, (item, key) => (
              <Option key={key} value={item[key]}>
                {key}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={8} lg={8}>
          <Select
            placeholder="Bedrooms"
            value={filters.meta && filters.meta.bedroomCount}
            style={{ width: '100%' }}
            onChange={value => handleChange({ bedroomCount: value }, 'meta')}
          >
            <Option key="all" value={-1}>
              Any
            </Option>
            <Option key="0" value={0}>
              Studio
            </Option>
            <Option key="1" value={1}>
              1
            </Option>
            <Option key="2" value={2}>
              2
            </Option>
            <Option key="3" value={3}>
              3
            </Option>
            <Option key="4" value={4}>
              4
            </Option>
          </Select>
        </Col>
        <Col span={8} lg={8}>
          <Select
            placeholder="Bathrooms"
            value={filters.meta && filters.meta.bathroomCount}
            style={{ width: '100%' }}
            onChange={value => handleChange({ bathroomCount: value }, 'meta')}
          >
            <Option key="all" value={-1}>
              Any
            </Option>
            <Option key="bathroomCount-0" value={0}>
              0
            </Option>
            <Option key="bathroomCount-1" value={1}>
              1
            </Option>
            <Option key="bathroomCount-2" value={2}>
              2
            </Option>
          </Select>
        </Col>
      </Row>
    </div>
  );
};

Filters.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func,
  role: PropTypes.string,
  setUnlocked: PropTypes.func
};

export default Filters;
